/*
 * @Author: huangzq
 * @Date: 2020-04-15 16:19:54
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-04-15 17:36:44
 * @Desc: 课件列表组件
*/
<template>
  <div class="import-list">
    <import-list-item
      v-for="(item,index) in courseWares"
      :key="item._id"
      :item="item"
      :index="index"
      :is-last="index===courseWares.length-1"
      @on-title-change="handelOnTitleChange"
      @on-preview="handelOnPreviewClick(item,index)"
      @on-play="handelOnPlayClick(item,index)"
      @on-up="handelOnUpClick(item,index)"
      @on-down="handelOnDownClick(item,index)"
      @on-delete="handelOnDeleteClick(item,index)"
    />

    <!-- 视频预览 -->
    <video-player
      v-if="showVideoPreview"
      :visible.sync="showVideoPreview"
      :url="currItem.url"
    />
  </div>
</template>

<script>
import ImportListItem from './import-list-item'

import VideoPlayer from '@/components/wechat-record/components/video-player'

export default {
  name: 'ImportList',
  components: { ImportListItem, VideoPlayer },
  props: {
    courseWares: {
      type: Array,
      default () {
        return [{
          // 营销资料ID
          _id: '',
          // 课件名
          courseWareName: '',
          // 营销资料封面图片
          cover: '',
          // 文件类型,MaterialType是文件的时候才有
          fileType: '',
          // 文件oss地址链接
          url: '',
          // 标签ID
          tags: [],
          // 营销资料类型 3文件、1图片、2视频，后续可添加案例库、宣传册等
          materialType: '',
          // 营销资料名字
          materialName: ''
        }]
      }
    }
  },
  data () {
    return {
      // 是否显示视频播放预览
      showVideoPreview: false,

      // 当前编辑的一项
      currItem: {}

    }
  },
  created () {},
  methods: {
    // 标题更改事件
    handelOnTitleChange (item) {
      this.currItem = item
      this.$emit('on-change')
    },

    // 预览
    handelOnPreviewClick (item, index) {
      this.currItem = item
      this.$emit('on-change')
    },
    // 播放
    handelOnPlayClick (item, index) {
      this.currItem = item
      this.$emit('on-change')
      this.showVideoPreview = true
    },
    // 上移
    handelOnUpClick (item, index) {
      this.currItem = item
      this.swapPage(this.courseWares, index, index - 1)
      this.$emit('on-change')
    },
    // 下移
    handelOnDownClick (item, index) {
      this.currItem = item
      this.swapPage(this.courseWares, index, index + 1)
      this.$emit('on-change')
    },
    // 删除
    handelOnDeleteClick (item, index) {
      this.currItem = item
      this.$emit('on-change')
      this.courseWares.splice(index, 1)
    },

    swapPage (arr, indexOne, indexTwo) {
      arr[indexOne] = arr.splice(indexTwo, 1, arr[indexOne])[0]
      return arr
    }
  }
}
</script>

<style lang='scss' scoped>
.import-list {
  color: #000;
}
</style>
